import ApprovalFlowDetail from './views/ApprovalFlowDetail.vue'
import CreateApprovalFlow from './views/CreateApprovalFlow.vue'
import ListApprovalFlows from './views/ListApprovalFlows.vue'
import ListApprovers from './views/ListApprovers.vue'
import RequestHistory from './views/RequestHistory.vue'
import RequestApprover from './views/RequestApprover.vue'
import RequestDetail from './views/RequestDetail.vue'
import EmployeesAssigned from './views/EmployeesAssigned.vue'
import HomeLayout from '@/layouts/Home.vue'

export const approverRoutes = [
  {
    path: '/approvers',
    name: 'approvers',
    component: ListApprovers,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin', 'admin users & supervisors'],
    },
  },
  {
    path: '/payrollsConfig/:id/approvalFlows',
    name: 'approvalFlows',
    component: ListApprovalFlows,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/approvalFlows/add',
    name: 'CreateApprovalFlow',
    component: CreateApprovalFlow,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/payrollsConfig/:id/approvalFlows/detail/:flowId',
    name: 'ApprovalFlowDetail',
    component: ApprovalFlowDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['admin', 'superadmin'],
    },
  },
  {
    path: '/requestHistory',
    name: 'RequestHistory',
    component: RequestHistory,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/requestApprover',
    name: 'RequestApprover',
    component: RequestApprover,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/requestDetail/:id/from/:from',
    name: 'RequestDetail',
    component: RequestDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor', 'admin', 'superadmin'],
    },
  },
  {
    path: '/requestApprover/:id',
    name: 'RequestApproverDetail',
    component: RequestDetail,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor'],
    },
  },
  {
    path: '/EmployeesAsigned',
    name: 'EmployeesAsigned',
    component: EmployeesAssigned,
    meta: {
      auth: true,
      layout: HomeLayout,
      requiredRoles: ['supervisor'],
    },
  },
]
